.progressOverride {
  margin-top: 0.5rem;
  height: 1rem;
  grid-area: progress;
}
